var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="new-lk-hr-notification"> <p> Внимание! Для представителей Юридических&nbsp;лиц запущен обновленный портал по управлению договорами корпоративного&nbsp;ДМС&nbsp;<a target="_blank"href="https://dms-corp.rgs.ru">dms-corp.rgs.ru</a>. </p> <div> <a target="_blank"href="https://dms-corp.rgs.ru">Перейти</a> <a target="_blank"href="https://www.rgs.ru/for-companies/zdorove/dmshr">Узнать подробнее</a> </div> </div>';
}
return __p;
};
